import React from 'react';
import "../ComponentsCss/SessionExpiredModal.css";

const SessionExpiredModal = ({ onSignIn }) => {
  return (
    <div className="session-expired-overlay" role="dialog" aria-labelledby="session-expired-title" aria-modal="true">
      <div className="session-expired-modal">
        <div className="session-expired-content">
          <h2 id="session-expired-title">You are signed out</h2>
          <p> Your session has ended.
           Sign in again to continue where you left off in SUSAN.</p>
          <button 
            onClick={onSignIn}
            className="btn btn-primary sign-in-btn"
          >
            Sign In Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
